import { Box, FieldWrapper } from '@dixa/lib-shared-habla';

import { KnowledgeBaseLinkPreview } from 'components/settings/components/sections/dixaMessenger/views/flow/components/shared/knowledgeBaseLinkPreview';
import { Option } from 'components/settings/components/sections/dixaMessenger/views/flow/flow.types';

import styles from './messengerMenuPreview.module.scss';

interface Props {
  text: string;
  options: Option[];
}

export const MessengerMenuPreview = ({ text, options }: Props): JSX.Element => {
  return (
    <FieldWrapper label="Preview" className={styles.root}>
      <div className={styles.container}>
        <div className={styles.messageContainer}>
          {!!text && (
            <>
              <Box
                className={styles.message}
                dangerouslySetInnerHTML={{ __html: text }}
              />
              <KnowledgeBaseLinkPreview text={text} />
            </>
          )}
        </div>
        <div className={styles.optionContainer}>
          {options.map((option) =>
            option.label ? (
              <div key={option.id} className={styles.option}>
                {option.label}
              </div>
            ) : null,
          )}
        </div>
      </div>
    </FieldWrapper>
  );
};
